import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";

export const GetAllMaintenanceRequestChat = createAsyncThunk(
  "dummyData/maintenanceRequestChat",
  async ( id) => {
    let response = await axios.get(
      `${BASE_URL}/get-maintenance-request-chat/${id}`
    );
    return response.data; // ALWAYS RETURN DATA ONLY
  }
);

const GetMaintenanceChat = createSlice({
  name: "maintenanceRequestChat",
  initialState: {
    loading: false,
    GetMaintenanceChat: [],
    error: "",
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllMaintenanceRequestChat.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllMaintenanceRequestChat.fulfilled, (state, action) => {
        state.loading = false;
        state.GetMaintenanceChat = action.payload;
      })
      .addCase(GetAllMaintenanceRequestChat.rejected, (state, action) => {
        state.loading = false; // FIX REQUIRED
        state.error = action.error.message;
      });
  },
});

export default GetMaintenanceChat.reducer;
